"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const token_1 = require("../../token");
const index_1 = require("@sensechat/crypto-interceptor/key/index");
const CODE_BASE = 1000000;
let refreshCount = 0;
let refreshTimer = null;
const response = (instance) => async (response) => {
    if (response.status === 401) {
        const isHK = location.pathname.indexOf("/hk") > -1;
        if (refreshCount < 5) {
            refreshCount++;
            clearTimeout(refreshTimer);
            refreshTimer = setTimeout(() => {
                refreshCount = 0;
            }, 10000);
            // token失效
            if (response.data.code % CODE_BASE === 150004) {
                const access = await (0, token_1.getToken)("accessToken");
                const refresh = await (0, token_1.getToken)("refreshToken");
                const refreshResponse = await instance
                    .post(`${location.origin}${isHK ? "/hk/" : "/"}api/auth/v2.1.0/refresh`, {
                    access,
                    refresh,
                })
                    .catch((error) => {
                    console.log("error", error);
                    return error.response;
                });
                console.log("refreshResponse", refreshResponse);
                let { status, data } = refreshResponse;
                if (status === 401) {
                    // 重新登录
                    await Promise.all([
                        (0, token_1.setToken)("accessToken", ""),
                        (0, token_1.setToken)("refreshToken", ""),
                    ]);
                    if (TARGET === "web") {
                        console.log("重新登录");
                        if (!window.__sensecommon?.isReloading) {
                            window.__sensecommon.isReloading = true;
                            location.href = `${location.origin}${isHK ? "/hk" : ""}/login`;
                        }
                    }
                    return;
                }
                else {
                    // 重新请求
                    const nextAccessToken = data.message.access;
                    const nextRefreshToken = data.message.refresh;
                    await Promise.all([
                        (0, token_1.setToken)("accessToken", nextAccessToken),
                        nextRefreshToken
                            ? (0, token_1.setToken)("refreshToken", nextRefreshToken)
                            : Promise.resolve(),
                    ]);
                    let nextParams = response.config.data;
                    if (response.config.data) {
                        const responseData = JSON.parse(response.config.data);
                        nextParams = await index_1.Crypto.decrypt(responseData.__data__);
                        nextParams = JSON.parse(nextParams);
                    }
                    console.log("nextParams", nextParams);
                    const nextResponse = await instance({
                        ...response.config,
                        data: nextParams,
                        headers: {
                            ...response.config.headers,
                            Authorization: `Bearer ${nextAccessToken}`,
                        },
                    });
                    return nextResponse;
                }
            }
            else {
                await Promise.all([
                    (0, token_1.setToken)("accessToken", ""),
                    (0, token_1.setToken)("refreshToken", ""),
                ]);
                if (!window.__sensecommon?.isReloading) {
                    window.__sensecommon.isReloading = true;
                    location.href = `${location.origin}${isHK ? "/hk" : ""}/login`;
                }
            }
        }
        else {
            throw Error("refresh too often");
        }
    }
    else {
        return response;
    }
};
exports.default = response;
